import {
  roofTypeLamonteraGambrel, roofTypeLamonteraHip, roofTypeLamonteraTented, roofTypeLamonteraMultiPitch, roofTypeLamonteraGable,
  roofTypeMontekristoGambrel, roofTypeMontekristoHip, roofTypeMontekristoTented, roofTypeMontekristoMultiPitch, roofTypeMontekristoGable,
  roofTypeMonterossaGambrel, roofTypeMonterossaHip, roofTypeMonterossaTented, roofTypeMonterossaMultiPitch, roofTypeMonterossaGable,
  roofTypeTramontaGambrel, roofTypeTramontaHip, roofTypeTramontaTented, roofTypeTramontaMultiPitch, roofTypeTramontaGable,
  roofTypeMP20Gambrel, roofTypeMP20Hip, roofTypeMP20Tented, roofTypeMP20MultiPitch, roofTypeMP20Gable,
  roofTypeS21Gambrel, roofTypeS21Hip, roofTypeS21Tented, roofTypeS21MultiPitch, roofTypeS21Gable,
} from 'src/assets/images';

import { RoofType } from 'src/store/roofData/types';

type ProfileType = 'Металлочерепица' | 'Профнастил' | string | undefined;
type MetalTileName = 'Ламонтерра' | 'Монтекристо' | 'Монтерроса' | 'Трамонтана' | string | undefined;
type PailingName = 'МП20' | 'С21' | string | undefined;

export const getRoofImage = (
  profileType: ProfileType,
  metalTileName: MetalTileName,
  pailingName: PailingName,
  roofType: RoofType | undefined,
): string => {
  switch (profileType) {
    case 'Металлочерепица':
      switch (metalTileName) {
        case 'Ламонтерра':
          switch (roofType) {
            case 'gambrel': return roofTypeLamonteraGambrel;
            case 'hip': return roofTypeLamonteraHip;
            case 'tented': return roofTypeLamonteraTented;
            case 'multipitch': return roofTypeLamonteraMultiPitch;
            case 'gable': return roofTypeLamonteraGable;
          }
          break;
        case 'Монтекристо':
          switch (roofType) {
            case 'gambrel': return roofTypeMontekristoGambrel;
            case 'hip': return roofTypeMontekristoHip;
            case 'tented': return roofTypeMontekristoTented;
            case 'multipitch': return roofTypeMontekristoMultiPitch;
            case 'gable': return roofTypeMontekristoGable;
          }
          break;
        case 'Монтерроса':
          switch (roofType) {
            case 'gambrel': return roofTypeMonterossaGambrel;
            case 'hip': return roofTypeMonterossaHip;
            case 'tented': return roofTypeMonterossaTented;
            case 'multipitch': return roofTypeMonterossaMultiPitch;
            case 'gable': return roofTypeMonterossaGable;
          }
          break;
        case 'Трамонтана':
          switch (roofType) {
            case 'gambrel': return roofTypeTramontaGambrel;
            case 'hip': return roofTypeTramontaHip;
            case 'tented': return roofTypeTramontaTented;
            case 'multipitch': return roofTypeTramontaMultiPitch;
            case 'gable': return roofTypeTramontaGable;
          }
          break;
      }
      break;

    case 'Профнастил':
      switch (pailingName) {
        case 'МП20':
          switch (roofType) {
            case 'gambrel': return roofTypeMP20Gambrel;
            case 'hip': return roofTypeMP20Hip;
            case 'tented': return roofTypeMP20Tented;
            case 'multipitch': return roofTypeMP20MultiPitch;
            case 'gable': return roofTypeMP20Gable;
          }
          break;
        case 'С21':
          switch (roofType) {
            case 'gambrel': return roofTypeS21Gambrel;
            case 'hip': return roofTypeS21Hip;
            case 'tented': return roofTypeS21Tented;
            case 'multipitch': return roofTypeS21MultiPitch;
            case 'gable': return roofTypeS21Gable;
          }
          break;
      }
      break;
  }

  return roofTypeLamonteraGambrel;
};
